import { useEffect } from 'react';

import PageBanner from '../../../components/Banner/PageBanner';
import Page from '../../../components/Page/Page';
import useGetReferralLeaderboard from '../../../hooks/dashboard/referrals/useGetReferralLeaderboard';
import useGetReferralSummary from '../../../hooks/dashboard/referrals/useGetReferralSummary';
import { useAppSelector } from '../../../redux/store';
import {
  ContentContainer,
  PageContainer,
  StatusActionLink,
  StatusNotice,
  PrimaryActionButton,
} from './Referral.styles';
import ReferralLeaderboard from './components/ReferralLeaderboard';
import ReferralLinkCard from './components/ReferralLinkCard';
import ReferralSummaryMetrics from './components/ReferralSummaryMetrics';
import { USERS_SETTINGS } from '../../../routes/routeConstants';

const Referrals = () => {
  const { getReferralSummary, loading: summaryLoading } = useGetReferralSummary();
  const {
    getReferralLeaderboard,
    loading: leaderboardLoading,
  } = useGetReferralLeaderboard();

  const summary = useAppSelector((state) => state.referral.summary);
  const leaderboard = useAppSelector((state) => state.referral.leaderboard);
  const leaderboardMode = useAppSelector(
    (state) => state.referral.leaderboardMode
  );
  const summaryError = useAppSelector((state) => state.referral.summaryError);
  const leaderboardError = useAppSelector(
    (state) => state.referral.leaderboardError
  );

  useEffect(() => {
    getReferralSummary();
    getReferralLeaderboard(leaderboardMode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="Locumspace | Referrals">
      <PageContainer>
        <PageBanner
          label="Referrals"
          description="Invite healthcare professionals and recruiters to Locumspace and earn rewards as they complete verification and reach Tier 3."
        />
        <ContentContainer>
          {summaryError ? (
            <StatusNotice role="alert">
              {summaryError}{' '}
              <PrimaryActionButton type="button" disabled={summaryLoading} onClick={getReferralSummary}>
                {summaryLoading ? 'Retrying...' : 'Try again'}
              </PrimaryActionButton>
            </StatusNotice>
          ) : summaryLoading ? (
            <StatusNotice>Loading your referral progress...</StatusNotice>
          ) : !summary?.isEligible ? (
            <StatusNotice>
              Referral rewards are unlocked once your account is verified and
              reaches Tier 3. Your referral dashboard is ready in advance so
              you can see how the programme works.{' '}
              <StatusActionLink to={`/${USERS_SETTINGS}`}>
                Go to settings to complete verification.
              </StatusActionLink>
            </StatusNotice>
          ) : summary?.leaderboardRank ? (
            <StatusNotice>
              You currently have {summary.points} referral points and rank #
              {summary.leaderboardRank} on the leaderboard.
            </StatusNotice>
          ) : (
            <StatusNotice>
              Your referral rewards, qualified referrals, and leaderboard
              progress will update here as soon as activity starts.
            </StatusNotice>
          )}
          {!summaryError && <>
            <ReferralSummaryMetrics summary={summary} />
            <ReferralLinkCard summary={summary} loading={summaryLoading} />
          </>}
          <ReferralLeaderboard
            entries={leaderboard}
            mode={leaderboardMode}
            loading={leaderboardLoading}
            onModeChange={getReferralLeaderboard}
            error={leaderboardError}
          />
        </ContentContainer>
      </PageContainer>
    </Page>
  );
};

export default Referrals;
